import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from "react";
import { NavLink } from "react-router-dom";
export var createLink = function createLink(menu, index, activeClass, _className) {
  return /*#__PURE__*/React.createElement(NavLink, {
    to: menu.link,
    key: index,
    className: function className(_ref) {
      var _context;

      var isActive = _ref.isActive;
      return _concatInstanceProperty(_context = "".concat(_className, " ")).call(_context, isActive ? activeClass : "");
    }
  }, menu.name);
};
export var getMenus = function getMenus(sideBarMenus) {
  var _context2;

  return _mapInstanceProperty(_context2 = sideBarMenus || []).call(_context2, function (menu) {
    var menuItem = {
      name: menu.name
    };

    if (menu.collapsible) {
      menuItem.collapsible = true;
      menuItem.items = getMenus(menu.items);
    } else {
      menuItem.link = menu.link;
      menuItem.renderComponent = createLink;
    }

    return menuItem;
  });
};